import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Mon Aug 06 2018
 * @author VBr
 * @author Tomáš Leity
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { action, observable, runInAction } from 'mobx';
import { StoreName } from '../StoreName';
import { BaseStore } from '../BaseStore';
import { GroupOfSitesLayer } from '../../transportLayers/site/GroupOfSitesLayer';
import { GroupOfSites } from '@logio/common-be-fe';
/**
 * This store obtaining data of price sites.
 */

export var GroupOfSitesStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(GroupOfSitesStore, _BaseStore);

  function GroupOfSitesStore() {
    var _this;

    _classCallCheck(this, GroupOfSitesStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(GroupOfSitesStore).apply(this, arguments));
    /** Store name */

    _this.name = StoreName.GroupOfSites;
    /** Layer contains methods for fetching data */

    _this.groupOfSitesLayer = new GroupOfSitesLayer();
    /** List of Themes */

    _this.list = new Map();
    return _this;
  }
  /**
   * Fetches GroupOfSites by defined filter params
   * @param groupOfSitesIds
   */


  _createClass(GroupOfSitesStore, [{
    key: "getFiltered",
    value: function getFiltered(groupOfSitesIds) {
      var _this2 = this;

      return this.groupOfSitesLayer.findFiltered(groupOfSitesIds).then(function (groupOfSites) {
        _this2.list.clear();

        runInAction(function () {
          groupOfSites.forEach(function (site) {
            if (site.id) {
              _this2.list = _this2.list.set(site.id, site);
            }
          });
        });
        return _this2.list;
      });
    }
    /**
     * Fetches one GroupOfSite
     * @param groupOfSiteId
     */

  }, {
    key: "getOne",
    value: function getOne(groupOfSiteId) {
      var _this3 = this;

      return this.groupOfSitesLayer.findOne(groupOfSiteId).then(function (groupOfSite) {
        runInAction(function () {
          _this3.list.set(groupOfSite.id, groupOfSite);
        });
        return groupOfSite;
      });
    }
    /**
     * Updates GroupOfSite data using GroupOfSitesLayer
     * @param groupOfSite
     */

  }, {
    key: "update",
    value: function update(groupOfSite) {
      var _this4 = this;

      return this.groupOfSitesLayer.update(groupOfSite).then(function (site) {
        runInAction(function () {
          _this4.list.set(site.id, site);
        });
      });
    }
    /**
     * Fetches GroupOfSites format defined by filter
     * @param filter
     */

  }, {
    key: "siteFormat",
    value: function siteFormat(filter) {
      return this.groupOfSitesLayer.siteFormat(filter);
    }
  }]);

  return GroupOfSitesStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Map)], GroupOfSitesStore.prototype, "list", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Array]), __metadata("design:returntype", Promise)], GroupOfSitesStore.prototype, "getFiltered", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], GroupOfSitesStore.prototype, "getOne", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [GroupOfSites]), __metadata("design:returntype", Promise)], GroupOfSitesStore.prototype, "update", null);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [Object]), __metadata("design:returntype", Promise)], GroupOfSitesStore.prototype, "siteFormat", null);